import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { RegionProvider } from "@/contexts/RegionContext"
import AgentPublicPage from "@/pages/AgentPublicPage"
import PropertyDetailPage from "@/pages/PropertyDetailPage"
import NotFound from "@/pages/NotFound"
import Loading from "@/pages/Loading"
import Login from "@/pages/Login"
import Register from "@/pages/Register"
import ForgotPassword from "@/pages/ForgotPassword"
import ResetPassword from "@/pages/ResetPassword"
import TermsPage from "@/pages/TermsPage"
import PrivacyPage from "@/pages/PrivacyPage"
import DashboardMain from "@/pages/DashboardMain"
import ProfilePage from "@/pages/ProfilePage"
import PropertiesPage from "@/pages/PropertiesPage"
import LeadsPage from "@/pages/LeadsPage"
import DocumentsPage from "@/pages/DocumentsPage"
import Settings from "@/pages/Settings"
import Analytics from "@/pages/Analytics"
import BillingPage from "@/pages/BillingPage"
import LandingPage from "@/pages/LandingPage"
import { useSubdomain } from "@/hooks/useSubdomain"
import ShortUrlResolver from "@/pages/ShortUrlResolver"
import NomCompliancePage from '@/pages/NomCompliancePage'

function AppContent() {
  const { subdomain, isValid, isLoading } = useSubdomain()

  if (isLoading) {
    return <Loading />
  }

  // Rutas principales (sin subdomain)
  if (!subdomain) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<DashboardMain />} />
          <Route path="/dashboard/profile" element={<ProfilePage />} />
          <Route path="/dashboard/properties" element={<PropertiesPage />} />
          <Route path="/dashboard/leads" element={<LeadsPage />} />
          <Route path="/dashboard/documents" element={<DocumentsPage />} />
          <Route path="/dashboard/settings" element={<Settings />} />
          <Route path="/dashboard/analytics" element={<Analytics />} />
          <Route path="/dashboard/billing" element={<BillingPage />} />
          <Route path="/dashboard/nom" element={<NomCompliancePage />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/p/:shortCode" element={<ShortUrlResolver />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          style={{ zIndex: 99999 }}
        />
      </Router>
    )
  }

  // Rutas públicas de agente (con subdomain)
  if (isValid && subdomain) {
    return (
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<AgentPublicPage subdomain={subdomain} />} />
            <Route path="/property/:propertyId" element={<PropertyDetailPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    )
  }

  return <NotFound />
}

function App() {
  return (
    <RegionProvider>
      <AppContent />
    </RegionProvider>
  )
}

export default App
